module.exports = __webpack_public_path__ + "static/media/appointmentOrder.641d8ca.ogg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mp3/appointmentOrder.ogg
// module id = kQdP
// module chunks = 4